var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-2",class:_vm.state.class,attrs:{"depressed":"","rounded":"","small":""}},[_vm._v(" "+_vm._s(_vm.state.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }